<script lang="ts">
    import Portal from "svelte-portal"
    import PopupNoPortal from "./PopupNoPortal.svelte"
    export let target = document.body
    let className = ""
    export let naked = false
    export let scrollable = true
    export let width: "max-w-lg" | "max-w-xl" | "max-w-2xl" = "max-w-lg"
    export { className as class }
</script>

<Portal {target}>
    <PopupNoPortal
        {scrollable}
        class={className}
        {width}
        {naked}
        on:clickoutside
        on:introend
        {...$$restProps}
    >
        <slot />
    </PopupNoPortal>
</Portal>
